<script>
import $ from "jquery"
import justifiedGallery from "justifiedGallery"

export default {
  data() {
    return {
      zoom: false,
      zoomIndex: 0,
      photos: {
        zoom: [],
        current: [],
        actives: [],
        favorites: [],
        album: [],
        rekognition: []
      }
    }
  },
  mounted() {
    this.$root.$on('openZoom', this.openZoom);
    this.$root.$on('closeZoom', this.closeZoom);
    this.$root.$on('addFavoritePhoto', this.addFavoritePhoto);
    this.$root.$on('removeFavoritePhoto', this.removeFavoritePhoto);
    this.$root.$on('addRekognitionPhotos', this.addRekognitionPhotos);

    this.$root.$on('addPhotoToAlbum', this.addPhotoToAlbum);
    this.$root.$on('removePhotoFromAlbum', this.removePhotoFromAlbum);
  },
  methods:  {
    openZoom(photo) {
      const image = this.findImage(photo)
      this.zoom = true
      this.photos.zoom = []
      this.photos.current = photo
      this.zoomIndex = image.index

      this.$nextTick(() => {
        this.photos.zoom = this.photos.actives
      });
    },
    closeZoom() {
      this.zoom = false
      this.photos.zoom = []
    },
    renderPhotos() {
      this.$nextTick(() => {
        $('#mosaicGallery').justifiedGallery({
          lastRow:    'nojustify',
          margins:    15,
          rowHeight:  150,
          randomize:  false,
          target:     false
        });
      })
    },
    async morePhotos(category) {
      let page = category.page + 1

      try {
        this.loading = true
        const response = await this.$http.post(
          `/api/v2/events/${this.eventId}/category_assets`,
          {
            page: page,
            category_id: category.id,
            competitor: this.competitorNumber
          }
        )

        if(response.status == 200 || response.status == 304) {
          this.loading = false
          const data = response.data
          this.appendPhotos(category, data.photos, data.page)
        }
      } catch (e) {
        this.loading = false
        console.log(e)
      }
    },
    appendPhotos(category, newPhotos, newCategoryPage) {
      this.$nextTick(() => {
        category.photos = [].concat(category.photos, newPhotos)
        category.page = newCategoryPage
        this.photos.actives = category.photos
        this.renderPhotos()
      });
    },
    addFavoritePhoto(photo) {
      this.photos.favorites.push(photo)
      this.setStatusPhoto(this.photos.rekognition, photo, true)
      this.setStatusPhoto(this.photos.current, photo, true)
      this.updateFavorites()

      this.$nextTick(() => {
        //photo.selected = true;
        $('#favoritesGallery').justifiedGallery('norewind')
      })
    },
    removeFavoritePhoto(photo) {
      var _this = this

      $(this.photos.favorites).each(function(index, el) {
        if(el.id == photo.id) {
          _this.photos.favorites.splice(index, 1)
          _this.renderPhotos()
        }
      })
      this.setStatusPhoto(this.photos.rekognition, photo, false)
      this.setStatusPhoto(this.photos.current, photo, false)
      this.updateFavorites()
    },
    addRekognitionPhotos(photos) {
      this.photos.rekognition = []
      this.currentCategory = ""

      this.$nextTick(() => {
        const category = this.eventCategories[1];
        this.photos.rekognition = photos;
        category.setPhotos(photos.length);

        if(category.visible) {
          this.currentCategory = this.faceCategory.id
          const el = document.getElementsByClassName("categories-scroll")[0].getBoundingClientRect(),
            top = el.top

          window.scrollTo(0, top)
        } else {
          this.$alertify.error(this.$t("errors.noResults"))
        }
      })
    },
    addPhotoToAlbum(photo) {
      this.setPhotoInAlbum(this.photos.rekognition, photo, true);
      this.setPhotoInAlbum(this.photos.current, photo, true);
    },
    removePhotoFromAlbum(photo) {
      const index = this.photos.actives.findIndex((el) => {
        return (el.id == photo.id)
      });

      if(index >= 0) {
        this.photos.actives.splice(index, 1);
        this.setPhotoInAlbum(this.photos.rekognition, photo, false);
        this.setPhotoInAlbum(this.photos.current, photo, false);
        this.renderPhotos();
      }
    },
    setStatusPhoto(photos, photo, selected) {
      $(photos).each(function(index, el) {
        if(el.id == photo.id) { el.selected = selected; }
      });
    },
    setPhotoInAlbum(photos, photo, selected) {
      $(photos).each(function(index, el) {
        if(el.id == photo.id) { el.in_album = selected; }
      });
    },    
    updateFavorites() {
      const category = this.eventCategories[0]
      category.setPhotos(this.photos.favorites.length)
    },
    findImage(photo) {
      let _this = this, image = {}, index = 0

      $(this.photos.actives).each(function(i, el) {
        if(el.id == photo.id) {
          index = i
          image = el
        }
      })
      return {index: index, photo: image}
    }
  },
  computed: {
    hasRekognition() {
      return (this.photos.rekognition.length > 0)
    },
    hasPhotos() {
      return (this.photos.actives.length > 0)
    },
    hasFavoritesPhotos() {
      return (this.totalFavoritesPhotos > 0)
    },
    totalFavoritesPhotos() {
      return (this.photos.favorites.length)
    },
    hasFreePhotos() {
      var sponsoreds = this.photos.favorites.map(function(photo) {
        return photo.sponsored;
      }).indexOf(true);
      return (sponsoreds >= 0)
    }   
  }
}
</script>
